import { Dialog } from '@headlessui/react';
import Button from '../../../basic/button';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import option from '../../../../container/lensWizard/main/inputs/select/components/recommended/option';
import {
  buildAnalytics,
  DataAnalyticsClicksFavorites,
  DataAnalyticsLocations,
  DataAnalyticsTypes,
} from '../../../basic/analytics';

interface FavoriteModalProps {
  isOpen: boolean;
  handleClose: (event?: React.MouseEvent | React.KeyboardEvent) => void;
  onSelected: () => void;
}
export default function FavoriteConfirmModal({
  isOpen,
  handleClose,
  onSelected,
}: FavoriteModalProps): JSX.Element {
  const { t } = useTranslation();

  return (
    <Dialog as="div" open={isOpen} onClose={handleClose} data-testid="favoriteConfirmRemoval-test">
      <div className="fixed inset-0 bg-black bg-opacity-25" />
      <div className="fixed inset-0 z-100 overflow-y-auto bg-black bg-opacity-25">
        <div className="flex items-center justify-center min-h-full">
          <Dialog.Panel className="relative bg-white w-[350px] rounded-lg p-[16px] lg:p-[50px] lg:w-[590px] lg:max-w-[590px]">
            <div className="flex flex-col h-full space-y-base mt-sm">
              <h2 className="text-slate-900 pb-1 text-base lg:text-[32px] lg:pb-4">
                {t('favorites.modal.title')}
              </h2>
              <span className="text-slate-900 text-sm lg:text-lg">
                {t('favorites.modal.description')}
              </span>

              <div className="text-center mx-auto flex flex-col lg:flex-row lg:mx-0 lg:justify-end">
                <Button
                  type="button"
                  className="text-center hover:text-white text-[13px] lg:text-base text-sky-700 leading-[17px] w-[204px] lg:w-[104px] h-9 lg:h-12 pl-4 pr-[15px] py-[9px] hover:bg-sky-700 bg-slate-100 cursor-pointer rounded-[100px] lg:round-3xl border border-sky-700 justify-center gap-2.5 inline-flex mb-2 lg:mb-0 lg:mr-3 focus:outline-none focus:ring-2 focus:ring-offset-1 focus:ring-sky-700"
                  onClick={handleClose}
                  onKeyDown={(e: React.KeyboardEvent<HTMLButtonElement>) => {
                    if (e.key === 'Enter') {
                      e.preventDefault();
                      e.stopPropagation();
                      if (
                        e.nativeEvent &&
                        typeof e.nativeEvent.stopImmediatePropagation === 'function'
                      ) {
                        e.nativeEvent.stopImmediatePropagation();
                      }
                      handleClose(e);
                    }
                  }}
                >
                  {t('favorites.modal.button.cancel')}
                </Button>

                <Button
                  type="button"
                  key={`favorite-remove-confirm`}
                  className="text-center text-white text-[13px] lg:text-base hover:text-sky-700 leading-[17px] w-[204px] h-9 lg:h-12 pl-4 pr-[15px] py-[9px] lg:p-5 lg:w-[238px] bg-sky-700 hover:bg-slate-100 cursor-pointer rounded-[100px] lg:round-3xl border border-sky-600 justify-center gap-2.5 inline-flex focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-sky-700"
                  onClick={onSelected}
                  onKeyDown={(e: React.KeyboardEvent<HTMLButtonElement>) => {
                    if (e.key === 'Enter') {
                      e.preventDefault();
                      e.stopPropagation();
                      if (
                        e.nativeEvent &&
                        typeof e.nativeEvent.stopImmediatePropagation === 'function'
                      ) {
                        e.nativeEvent.stopImmediatePropagation();
                      }
                      onSelected();
                    }
                  }}
                  dataAnalytics={buildAnalytics(
                    DataAnalyticsLocations.Dialog,
                    DataAnalyticsTypes.Button,
                    [DataAnalyticsLocations.Body],
                    DataAnalyticsClicksFavorites.DELETE_EYEGLASS_FRAME_FAVORITE,
                  )}
                >
                  {t('favorites.modal.button.remove')}
                </Button>
              </div>
            </div>
          </Dialog.Panel>
        </div>
      </div>
    </Dialog>
  );
}
